(function ($) {
    'use strict';

    function showAjaxAlert(type, message) {
        const alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
        const iconClass = type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill';

        const html = `
            <div class="alert ${alertClass} alert-dismissible fade show d-flex align-items-center gap-2 py-2 px-3 rounded-3 shadow-sm" role="alert">
                <i class="bi ${iconClass} fs-5"></i>
                <div class="flex-grow-1">${message}</div>
                <button type="button" class="btn-close ms-2 align-self-center" data-bs-dismiss="alert"></button>
            </div>
        `;

        $('#settingsAjaxAlert').html(html);
    }

    function clearValidationErrors(form) {
        $(form).find('.is-invalid').removeClass('is-invalid');
        $(form).find('.invalid-feedback.ajax-invalid-feedback').remove();
    }

    function showValidationErrors(form, errors) {
        if (!errors) {
            return;
        }

        Object.keys(errors).forEach(function (fieldName) {
            const input = $(form).find(`[name="${fieldName}"]`);
            if (!input.length) {
                return;
            }

            input.addClass('is-invalid');

            const messages = Array.isArray(errors[fieldName])
                ? errors[fieldName].join('<br>')
                : String(errors[fieldName]);

            const feedback = `<div class="invalid-feedback ajax-invalid-feedback">${messages}</div>`;

            if (input.hasClass('form-check-input')) {
                input.closest('.form-check').after(feedback);
            } else {
                input.after(feedback);
            }
        });
    }

    function setSubmitting(form, isSubmitting) {
        const btn = $(form).find('button[type="submit"]').first();

        if (!btn.length) {
            return;
        }

        if (isSubmitting) {
            btn.data('original-text', btn.html());
            btn.prop('disabled', true).html(
                '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Saving...'
            );
        } else {
            btn.prop('disabled', false).html(btn.data('original-text') || 'Save');
        }
    }

    function bindAjaxSettingsForms() {
        $(document).on('submit', '.js-ajax-settings-form', function (e) {
            e.preventDefault();

            const form = this;
            const $form = $(form);
            const action = $form.attr('action');
            const method = ($form.attr('method') || 'post').toUpperCase();
            const formData = $form.serialize();

            clearValidationErrors(form);
            setSubmitting(form, true);

            $.ajax({
                url: action,
                method: method,
                data: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                }
            })
                .done(function (response) {
                    if (response && response.ok) {
                        showAjaxAlert('success', response.message || 'Settings saved successfully.');
                    } else {
                        showAjaxAlert('error', (response && response.message) || 'Unable to save settings.');
                        showValidationErrors(form, response && response.errors ? response.errors : null);
                    }
                })
                .fail(function (xhr) {
                    let response = null;

                    try {
                        response = xhr.responseJSON || JSON.parse(xhr.responseText);
                    } catch (err) {
                        response = null;
                    }

                    if (response && response.message) {
                        showAjaxAlert('error', response.message);
                        showValidationErrors(form, response.errors || null);
                    } else {
                        showAjaxAlert('error', 'Something went wrong while saving. Please try again.');
                    }
                })
                .always(function () {
                    setSubmitting(form, false);
                });
        });
    }

    $(function () {
        bindAjaxSettingsForms();
    });

})(jQuery);